/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ForecastModelRecordDataFileReport', 'model/ForecastModelRecordDataTransferLog'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./ForecastModelRecordDataFileReport'), require('./ForecastModelRecordDataTransferLog'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ForecastModelRecordDataReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ForecastModelRecordDataFileReport, root.ForStractionServiceApi.ForecastModelRecordDataTransferLog);
  }
}(this, function(ApiClient, ForecastModelRecordDataFileReport, ForecastModelRecordDataTransferLog) {
  'use strict';




  /**
   * The ForecastModelRecordDataReport model module.
   * @module model/ForecastModelRecordDataReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>ForecastModelRecordDataReport</code>.
   * @alias module:model/ForecastModelRecordDataReport
   * @class
   */
  var exports = function() {
    var _this = this;
















  };

  /**
   * Constructs a <code>ForecastModelRecordDataReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ForecastModelRecordDataReport} obj Optional instance to populate.
   * @return {module:model/ForecastModelRecordDataReport} The populated <code>ForecastModelRecordDataReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Files')) {
        obj['Files'] = ApiClient.convertToType(data['Files'], [ForecastModelRecordDataFileReport]);
      }
      if (data.hasOwnProperty('LogMessages')) {
        obj['LogMessages'] = ApiClient.convertToType(data['LogMessages'], [ForecastModelRecordDataTransferLog]);
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('LastRunTime')) {
        obj['LastRunTime'] = ApiClient.convertToType(data['LastRunTime'], 'Date');
      }
      if (data.hasOwnProperty('ImportPeriodTypeID')) {
        obj['ImportPeriodTypeID'] = ApiClient.convertToType(data['ImportPeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('ImportAfterCustomPeriod')) {
        obj['ImportAfterCustomPeriod'] = ApiClient.convertToType(data['ImportAfterCustomPeriod'], 'Date');
      }
      if (data.hasOwnProperty('StopOnEmptyRow')) {
        obj['StopOnEmptyRow'] = ApiClient.convertToType(data['StopOnEmptyRow'], 'Boolean');
      }
      if (data.hasOwnProperty('ImportActual')) {
        obj['ImportActual'] = ApiClient.convertToType(data['ImportActual'], 'Boolean');
      }
      if (data.hasOwnProperty('ImportBudget')) {
        obj['ImportBudget'] = ApiClient.convertToType(data['ImportBudget'], 'Boolean');
      }
      if (data.hasOwnProperty('ImportForecast')) {
        obj['ImportForecast'] = ApiClient.convertToType(data['ImportForecast'], 'Boolean');
      }
      if (data.hasOwnProperty('SetLastConfirmedFinancialPeriod')) {
        obj['SetLastConfirmedFinancialPeriod'] = ApiClient.convertToType(data['SetLastConfirmedFinancialPeriod'], 'Boolean');
      }
      if (data.hasOwnProperty('NegateImportedCostAccountNumbers')) {
        obj['NegateImportedCostAccountNumbers'] = ApiClient.convertToType(data['NegateImportedCostAccountNumbers'], 'Boolean');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/ForecastModelRecordDataFileReport>} Files
   */
  exports.prototype['Files'] = undefined;
  /**
   * @member {Array.<module:model/ForecastModelRecordDataTransferLog>} LogMessages
   */
  exports.prototype['LogMessages'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Date} LastRunTime
   */
  exports.prototype['LastRunTime'] = undefined;
  /**
   * @member {Integer} ImportPeriodTypeID
   * @default 0
   */
  exports.prototype['ImportPeriodTypeID'] = 0;
  /**
   * @member {Date} ImportAfterCustomPeriod
   */
  exports.prototype['ImportAfterCustomPeriod'] = undefined;
  /**
   * @member {Boolean} StopOnEmptyRow
   * @default false
   */
  exports.prototype['StopOnEmptyRow'] = false;
  /**
   * @member {Boolean} ImportActual
   * @default false
   */
  exports.prototype['ImportActual'] = false;
  /**
   * @member {Boolean} ImportBudget
   * @default false
   */
  exports.prototype['ImportBudget'] = false;
  /**
   * @member {Boolean} ImportForecast
   * @default false
   */
  exports.prototype['ImportForecast'] = false;
  /**
   * @member {Boolean} SetLastConfirmedFinancialPeriod
   * @default false
   */
  exports.prototype['SetLastConfirmedFinancialPeriod'] = false;
  /**
   * @member {Boolean} NegateImportedCostAccountNumbers
   * @default false
   */
  exports.prototype['NegateImportedCostAccountNumbers'] = false;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


